import Footer from '@components/_rolex/Page/Footer'
import { Footer as GassanFooter, Header as GassanHeader } from '@components/Page'
import { FC, PropsWithChildren } from 'react'
import RCPOHeader from './Header'
import { RolexRCPOPageTypeTracking } from './PageTypeTracking'

type RCPOPageTypes =
  | 'home page'
  | 'selection page'
  | 'model page'
  | 'certification page'
  | 'programme page'
  | 'contact page'
  | 'store contact page'
  | 'contact form page'

export type RCPOPageProps = PropsWithChildren<{
  pageType: RCPOPageTypes
  productFamily?: string
  productRMC?: string
}>

export const RCPOPage: FC<RCPOPageProps> = ({ children, ...props }) => {
  return (
    <>
      <RolexRCPOPageTypeTracking {...props} />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[9999] focus:rounded focus:bg-rolexPrimary focus:px-4 focus:py-2 focus:text-white focus:outline-none focus:ring-2 focus:ring-rolexOceanGreen"
      >
        Skip to main content
      </a>
      <GassanHeader initialVariant="absolute" />
      <div className="mx-auto max-w-[109rem]">
        <RCPOHeader />
        <main id="main-content">{children}</main>
        <Footer variant="rcpo" />
      </div>
      <GassanFooter />
    </>
  )
}
